const CLASSROOM_DATA_CHANGED_EVENT = "ha:classroom-data-changed";

export function notifyClassroomDataChanged(payload = {}) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(CLASSROOM_DATA_CHANGED_EVENT, {
      detail: {
        ...payload,
        at: Date.now(),
      },
    })
  );
}

export function subscribeClassroomDataChanged(handler) {
  if (typeof window === "undefined" || typeof handler !== "function") {
    return () => {};
  }

  const listener = (event) => {
    try {
      handler(event?.detail || {});
    } catch {
      // no-op
    }
  };

  window.addEventListener(CLASSROOM_DATA_CHANGED_EVENT, listener);
  return () =>
    window.removeEventListener(CLASSROOM_DATA_CHANGED_EVENT, listener);
}
